import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { CustomerBannerData } from '@models/customer-banner';
import { environment } from '@env/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root',
})
export class CustomerBannerService {
  constructor(
    private http: HttpClient,
    private deviceService: DeviceDetectorService,
  ) {}

  private customerBannerSource = new BehaviorSubject<any>(null);
  private allCustomerBanners = new BehaviorSubject<CustomerBannerData[]>(null);

  setCustomerBannerData(val) {
    this.customerBannerSource.next(val);
  }

  setAllCustomerBannersData(banners: CustomerBannerData[]) {
    this.allCustomerBanners.next(banners);
  }

  getCustomerBannerData() {
    return this.customerBannerSource.asObservable();
  }

  getAllCustomerBannersData(): Observable<CustomerBannerData[]> {
    return this.allCustomerBanners.asObservable();
  }
  clearCustomerBannerData() {
    this.customerBannerSource.next(null);
  }
  getFlagForPolicyType(policyTypes) {
    if (policyTypes.length === 2) {
      return 3;
    } else if (policyTypes[0] === 'AUTO') {
      return 1;
    } else if (policyTypes[0] === 'HOME') {
      return 2;
    } else {
      return 0;
    }
  }
  public getCustomerBannerDataFromAPI(
    policyTypes,
    deviceType
  ): Observable<CustomerBannerData> {
    const policyTypeFlag = this.getFlagForPolicyType(policyTypes);
    const url = `${environment.backend_server_url_account}/generic/customer-banner-new?device=${deviceType}&policyType=${policyTypeFlag}`;
    return this.http.get<CustomerBannerData>(url);
  }

  private static readonly GW_POLICY_NUMBER_LENGTH = 10;

  public loadAllCustomerBanners(policyDetails: any[]) {

    const existActiveTW = policyDetails?.some(policy =>
      policy.company?.companyName === "TW" && policy.policyStatus === "ACTIVE"
    );
    const existActiveGW = policyDetails?.some(policy =>
      policy.policynumber?.policyNumber?.length === CustomerBannerService.GW_POLICY_NUMBER_LENGTH && policy.policyStatus === "ACTIVE"
    );
    const existNonActiveGW = policyDetails?.some(policy =>
        policy.policynumber?.policyNumber?.length === CustomerBannerService.GW_POLICY_NUMBER_LENGTH && policy.policyStatus !== "ACTIVE"
    );

    let bannerObservable: Observable<CustomerBannerData[]>;

    if (existActiveGW) {
      bannerObservable = this.getAllCustomerBanners('GWMA');
    } else if (existActiveTW) {
      bannerObservable = this.getAllCustomerBanners('TW');
    } else if (existNonActiveGW) {
      bannerObservable = this.getAllCustomerBanners();
    } else {
      return;
    }

    bannerObservable.pipe(take(1)).subscribe(bannersRes => {
      if(bannersRes){
        this.setAllCustomerBannersData(bannersRes);
      }
    });
  }

   public getAllCustomerBanners(company?: string): Observable<CustomerBannerData[]> {    
    let params = new HttpParams().set('device', this.getDeviceType());
    if(company){
      params = params.set('polCompany', company)
    }
    const url = `${environment.backend_server_url_account}/generic/all-customer-banners`;
    // const url = `/b2c-account/v1/generic/all-customer-banners`;
    return this.http.get<CustomerBannerData[]>(url, { params });
  }

  private getDeviceType() {
    let signedSource;
    if (!Capacitor.isNativePlatform()) {
      if (this.deviceService.isDesktop()) {
        signedSource = 'd';
      } else if (this.deviceService.isTablet()) {
        signedSource = 't';
      } else if (this.deviceService.isMobile()) {
        signedSource = 'm';
      } else {
        signedSource = '';
      }
    } else {
      signedSource = 'm';
    }
    return signedSource;
  }
}
